import { useCallback, useEffect, useMemo, useState } from 'react'
import './GiftPack.less'
import { Drawer, Form, InputItem, TextareaItem, Button } from 'dingtalk-design-mobile'
import dd from '@/utils/dd.config'
import AddressModal from '@/components/AddressModal/AddressModal'
import { _submitPickGift, _checkGiftPack } from '@/api/user'
import DingweiIcon from '@/assets/images/dingwei.png'
import SelectImg from '@/assets/images/duigou.png'

const GiftPack = () => {
  const [list, setList] = useState([
    {
      id: 1,
      title: '礼包1',
      img: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/giftPack/pack01.png',
      isPick: false
    },
    {
      id: 2,
      title: '礼包2',
      img: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/giftPack/pack02.png',
      isPick: false
    },
    {
      id: 3,
      title: '礼包3',
      img: 'https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/giftPack/pack03.png',
      isPick: false
    },
  ])

  const addressList = [
    {id: 0, name: '东区街道办事处', address: '东区中山五路63号'},
    {id: 1, name: '东区人社分局', address: '东区长江北路161-163号'},
    {id: 2, name: '综合行政执法局', address: '东区桃苑路16号'},
    {id: 3, name: '东区街道社区卫生服务中心', address: '东区桃苑路16号'},
    {id: 4, name: '东区行政服务中心', address: '东区起湾北道12号华鸿水云轩5期7幢1层行政服务中心大厅(紫茵庭园正门对面)'},
  ]

  const [showModal, setShowModal] = useState(false)
  const [checkPack, setCheckPack] = useState({})
  const [isGetGift, setIsGetGift] = useState(false)

  const [selectAddress, setSelectAddress] = useState(null)
  
  const handleClick = useCallback((item) => {
    if (isGetGift){
      dd.toast('error', '您已领取过了')
      return
    }
    setShowModal(true)
    setCheckPack(item)
  }, [ showModal, checkPack, isGetGift ])

  const handleSubmit = useCallback(() => {
    if (selectAddress === null){
      dd.toast('error', '请选择自提点')
      return
    }
    const params = {
      giftId: checkPack.id,
      detail: addressList[selectAddress].name,
    }
    // console.log('params', params)
    _submitPickGift(params).then(([success, res]) => {
      if(success && res) {
        dd.toast('success', '领取成功')
        setShowModal(false)
        checkGiftPack()
      } else {
        dd.toast('error', '暂无领取权限，请联系管理员')
      }
    })
  }, [ checkPack, selectAddress ])




  // 礼包领取情况
  const checkGiftPack = () => {
    _checkGiftPack().then(([success, res]) => {
      if(success && res?.length) {
        setIsGetGift(true);
        setList(_list => _list.map(item => {
          res.forEach(_item => {
            if (item.id === _item) {
              item.isPick = true
            }
          })
          return item
        }))
      }
    })
  }

  const handleVisibleChange = useCallback(() => {
    setShowModal(false)
    setSelectAddress(null)
  }, [showModal, selectAddress])

  const handleSelect = useCallback((id) => {
    setSelectAddress(id)
  }, [selectAddress])

  useEffect(() => {
    checkGiftPack()
  }, [])

  return (
    <div className='pg-giftpack'>
      <img className='pg-header' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/giftPack/header.png' />
      <div className='pg-giftpack-container'>
        <img className='giftpack-tips' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/giftPack/tips.png' />
        {
          list.map(item => {
            return (
              <div key={ item.id } className='card--wrap'>
                <div className='card--header'>
                  <div className='pack-name'>{ item.title }</div>
                  {
                    item.isPick ? 
                    <div className='pick-btn is-pick' onClick={() => handleClick()}>已领取</div> :
                    <div className={isGetGift ? 'pick-btn is-pick' : 'pick-btn'} onClick={() => handleClick(item)}>立即领取</div>
                  }
                </div>
                <img className='pack-img' src={ item.img } />
              </div>
            )
          })
        }
      </div>
      <Drawer
        size="large"
        title={'确认领取-' + checkPack.title}
        visible={showModal}
        onVisibleChange={handleVisibleChange}
      >
        <div className='modal-pack-img--wrap'>
          <img src={ checkPack.img } />
        </div>
        <div className='modal-pack-form'>
          <div className='title'><img src={ DingweiIcon } />请选择自提点</div>
          {
            addressList.map(item => {
              return (
                <div key={item.id} className='address--row'>
                  <div className='address--detail'>
                    <div className='title'>{ item.name }</div>
                    <div className='address'>{ item.address }</div>
                  </div>
                  {
                    selectAddress === item.id ?
                    <img className='select-img' src={ SelectImg } /> :
                    <div className='select-icon' onClick={() => handleSelect(item.id)}></div>
                  }
                </div>
              )
            })
          }
          <Button className='form-btn' onClick={handleSubmit}>确认领取</Button>
        </div>
      </Drawer>
    </div>
  )
}

export default GiftPack